import _ from "lodash";
import { TopStocksConstants } from "../actions/topStocks";

const handlers = {
  [TopStocksConstants.TOP_STOCKS_REQUEST]: (_state: TopStocksState, _action: TopStocksAction): TopStocksState => ({
    errorMessage: "",
  }),
  [TopStocksConstants.TOP_STOCKS_SUCCESS]: (state: TopStocksState, action: TopStocksAction): TopStocksState => {
    if (_.isUndefined(action.payload)) return state
    return {
      content: {
        strongStocks: action.payload.strong_stocks,
        improvingStocks: action.payload.improving_stocks,
        weakStocks: action.payload.weak_stocks,
        weakeningStocks: action.payload.weakening_stocks,
      },
      errorMessage: undefined,
    }
  },
  [TopStocksConstants.TOP_STOCKS_FAILURE]: (_state: TopStocksState, action: TopStocksAction): TopStocksState => ({
    errorMessage: action.error,
  }),
};

export function topStocks(state: TopStocksState = {}, action: TopStocksAction): TopStocksState {
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  if (handlers[action.type]) {
    return handlers[action.type].call(null, state, action);
  }
  return state;
}
